import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <p>© 2026 Friction Studios. All rights reserved. <span className="footer-sep">·</span> <a className="footer-link" href="/privacy.html">Privacy Policy</a></p>
      </div>
    </footer>
  );
}

export default Footer;
